import * as THREE from 'three';

import AbstractObject from '../misc/object';

export default class Line extends AbstractObject {

  constructor({ from, to, color, path, disableDepthTest, dashed, customMaterial }) {
    super();

    let material = null;

    if (customMaterial){
      material = customMaterial;
    } else {
      if (dashed) {
        material = new THREE.LineDashedMaterial({
          color: color || 0x000000,
          linewidth: 1,
          scale: 1,
          dashSize: 3,
          gapSize: 1
        });
      } else {
        material = new THREE.LineBasicMaterial({ color: color || 0x000000 });
      }
    }

    if (disableDepthTest) {
      material.depthTest = false;
      material.depthWrite = false;
    }

    const geometry = new THREE.BufferGeometry();
    var linePositions = [];
    if (from && to) {
      linePositions.push(from.x, from.y, from.z);
      linePositions.push(to.x, to.y, to.z);
    } else if (path.length) {
      for (let i = 0; i < path.length; i++) {
        linePositions.push(path[i].x, path[i].y, path[i].z);
      }
    }

    if (linePositions.length > 1)
      geometry.setAttribute('position', new THREE.Float32BufferAttribute(linePositions, 3));

    const line = new THREE.Line(geometry, material);
    line.frustumCulled = false;

    if (dashed) {
      // VladP: Three.js version was changed and computeLineDistances was removed from geometry
      //geometry.computeLineDistances();
      line.computeLineDistances();
    }

    this.object.addMesh(line);
  }

}




// WEBPACK FOOTER //
// ./src/object-view/objects/line.js